import { computed } from 'vue'
import { useStore } from 'vuex'

import { featureLimit, featureLocked, featureOn, featureState, resolveEntitlements } from '@/helpers/entitlements'

export function useEntitlements() {
  const store = useStore()
  const user = computed(() => store.state.loggedInUser)
  return {
    user,
    entitlements: computed(() => resolveEntitlements(user.value)),
    state: key => featureState(user.value, key),
    on: key => featureOn(user.value, key),
    limit: key => featureLimit(user.value, key),
    locked: key => featureLocked(user.value, key)
  }
}
